module.exports = __webpack_public_path__ + "img/20300____-12.prt.d9264a03.jpg";